import {
  ListFilters,
  TagTypes,
} from "apps/customLists/components/filterScreens";
import { EnumListType, TagByIdsQuery, TagGroupByIdsQuery } from "gql/generated";
import {
  Bell,
  Calendar,
  Dollar,
  Eye,
  Fishing,
  Label,
  MapPin,
  MediaImage,
  PharmacyCrossCircle,
  ShopFourTiles,
  SnowFlake,
  TextSquare,
} from "iconoir-react";
import { ForwardRefExoticComponent, RefAttributes, SVGProps } from "react";
import { getMultilingualString } from "shared/utils";

export type FilterScreenType = FilterKey | "ALL";

export type FilterScreenProps = {
  type: EnumListType;
  onScreenChange: (screen: FilterScreenType) => void;
  currentScreenFilterOption?: FilterOptionItem;
};

export type FilterKey =
  | "OPERATOR_TYPE"
  | "KEYWORD_TAGS"
  | "AMENITY_TAGS"
  | "BACK_OFFICE_TAGS"
  | "PRICING"
  | "MEDIA_QUALITY"
  | "OPENING_STATUS"
  | "DAYS_OF_OP"
  | "SEASONALITY"
  | "OPERATOR_VISIBILITY"
  | "DIGITAL_HEALTH" 
  | "LOCATION";

export type FilterOptionItem = {
  key: FilterKey;
  icon: ForwardRefExoticComponent<
    Omit<SVGProps<SVGSVGElement>, "ref"> & RefAttributes<SVGSVGElement>
  >;
};

export const filterOptions: FilterOptionItem[] = [
  { key: "OPERATOR_TYPE", icon: Fishing },
  { key: "KEYWORD_TAGS", icon: TextSquare },
  { key: "AMENITY_TAGS", icon: Bell },
  { key: "BACK_OFFICE_TAGS", icon: Label },
  { key: "PRICING", icon: Dollar },
  { key: "MEDIA_QUALITY", icon: MediaImage },
  { key: "OPENING_STATUS", icon: ShopFourTiles },
  { key: "DAYS_OF_OP", icon: Calendar },
  { key: "SEASONALITY", icon: SnowFlake },
  { key: "OPERATOR_VISIBILITY", icon: Eye },
  { key: "DIGITAL_HEALTH", icon: PharmacyCrossCircle },
  { key: "LOCATION", icon: MapPin }
];

type getFilterTagsFromTagsProps = {
  tags: TagByIdsQuery["tagByIds"];
  tagGroups: TagGroupByIdsQuery["tagGroupByIds"];
  appliedFilters: ListFilters;
  tagKey: keyof TagTypes;
};

/**
 * This function gets all the names of tags and/or tagGroups to be displayed
 * on the list filter card when certain tags/tagGroups have been applied to
 * the list
 * @param param0
 * @returns
 */
export const getTagsNamesForTagRelatedFilters = ({
  appliedFilters,
  tagGroups,
  tags,
  tagKey,
}: getFilterTagsFromTagsProps) => {
  const appliedTags = tags
    // Filter out tags of a different tagGroup
    .filter(
      (tag) =>
        !appliedFilters.filledTagGroups[tagKey].includes(tag.tagGroup?._id),
    )
    // Filter out tags that aren't of the same tagKey
    .filter((tag) => appliedFilters.tags[tagKey].includes(tag._id));

  return (
    tagGroups
      // Filter out tag groups that aren't of the same tagKey
      .filter((group) =>
        appliedFilters.filledTagGroups[tagKey].includes(group._id),
      )
      // Get only the tagGroup names
      .map((group) => getMultilingualString(group.name))
      // Concatinate the tag names
      .concat(appliedTags.map((tag) => getMultilingualString(tag.name)))
      // Sort the names alphabetically
      .sort()
  );
};
